module.exports = __webpack_public_path__ + "static/media/test.561de423.jpg";